import { faExclamationCircle, faPlus, } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import ButtonIcon from '../../common/ButtonIcon';
import Flex from '../../common/Flex';
import PageHeader from '../../common/PageHeader';
import { createPriceRoot, editPriceRoot, getConfigAsRoot } from '../../../helpers/api/root';
import handleErrorMessage from '../../../helpers/errors/handleErrorMessage';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import { Toast } from '../../UI/toast/Toast';
import { Message, Or, PreloadState } from '../../UI/preloading/PreloadState';
import { isIterableArray } from '../../../helpers/utils';
import ConfigRow from './components/configRow';
import AddConfigRoot from './components/addConfigRoot';

const RootConfig = () => {

    const [ranges, setRanges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submittingSave, setSubmittingSave] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [min, setMin] = useState(1);
    const [max, setMax] = useState(2);
    const [price, setPrice] = useState(null)
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        let isMounted = true;
        getConfig(isMounted);
        return () => { isMounted = false; }
    }, [])

    const getConfig = (isMounted) => {
        isMounted && setLoading(true);
        getConfigAsRoot()
            .then(({ data }) => { isMounted && setRanges(data); })
            .catch(error => handleErrorMessage(error))
            .finally(() => { isMounted && setLoading(false); });
    }

    const saveRange = () => {
        setSubmittingSave(true);
        createPriceRoot(min, max, price)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ title: 'Configuración creada exitosamente.', type: 'success' });
                }
            })
            .catch(error => handleErrorMessage(error))
            .finally(() => {
                setSubmittingSave(false);
                setIsOpen(false);
                getConfig(true);
                setMin(1);
                setMax(2);
                setPrice(null);
            })
    }

    const editRange = (id, min, max, price) => {
        setSubmitting(true);
        editPriceRoot(id, min, max, price)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ title: 'Configuración editada exitosamente.', type: 'success' });
                    getConfig();
                }
            })
            .catch(error => handleErrorMessage(error))
            .finally(() => setSubmitting(false));
    }

    const closeBtn = <>
        <Button className="close font-weight-normal bg-transparent border-0 shadow-none" onClick={toggle}>
            &times;
        </Button>
    </>

    return <>
        <PageHeader
            title='Configuración de precios'
            titleTag="h2"
            description="Configuración de precios por propiedad del sistema."
            className="mb-3"
            col={{ lg: 9 }}
        />

        <Card>
            <CardHeader className='bg-light'>
                <Flex align='center' justify='between'>
                    <h5>Configuración de precios</h5>
                    <ButtonIcon icon={faPlus} color='falcon-default' size='md' className='px-5' transform="down-1 shrink-4" onClick={() => setIsOpen(true)} >Añadir rango de propiedades</ButtonIcon>
                </Flex>
            </CardHeader>
            <CardBody>
                <PreloadState cond={isIterableArray(ranges)} loading={loading}>
                    <Or value={true}>
                        {ranges.map((val, i) => (<ConfigRow key={i} {...val} submitting={submitting} editRange={editRange} />))}
                    </Or>
                    <Or value={false}>
                        <Message className='py-3' color='info' icon={faExclamationCircle}>No hay rangos para mostrar.</Message>
                    </Or>
                </PreloadState>
            </CardBody>
            <AddConfigRoot min={min} setMin={setMin} max={max} setMax={setMax} price={price} setPrice={setPrice} closeBtn={closeBtn} isOpen={isOpen} saveRange={saveRange} submittingSave={submittingSave} toggle={toggle} />
        </Card>
    </>
}

export default RootConfig;